'use client'

import { Stack, FormControlLabel, Checkbox } from '@mui/material'
import { useTranslations } from 'next-intl'

type Props = {
    selectedFilters: string[]
    onFilterChange: (label: string, checked: boolean) => void
}

const filters = {
    checkinBaggage: 'Check-in luggage',
    seat: 'Free seat selection',
    meal: 'Free meal selection',
}

export default function FareSelectionFilters({ selectedFilters, onFilterChange }: Props) {
    const tFareFamily = useTranslations('fareFamily');
    return (
        <Stack direction="row" flexWrap="wrap" sx={{ width: '100%', mb: 1, userSelect: 'none' }}>
            {Object.entries(filters).map(([key, value],index) => (
                <FormControlLabel
                    key={index}
                    control={
                        <Checkbox
                            size="small"
                            checked={selectedFilters.includes(key)}
                            onChange={(e) => onFilterChange(key, e.target.checked)}
                            sx={{
                                gap: '0.75rem',
                                '& input': { opacity: 1, width: '0.9rem' },
                                '& .MuiSvgIcon-root': { fontSize: '0rem' },
                            }}
                        />
                    }
                    label={tFareFamily(value)}
                    sx={{
                        m: 0,
                        '& .MuiFormControlLabel-label': {
                            fontSize: '0.85rem',
                            mr: '1.8rem',
                            ml:'0.3rem',
                            lineHeight: 1.6,
                        },
                    }}
                />
            ))}
        </Stack>
    )
}